import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import React, { memo, useEffect, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import IdentificationDocumentForm from '../shared/form-identification-document';
import { FormikErrors, FormikProps, FormikTouched } from 'formik';
import { IdentificationDocument, PersonalDataVM } from 'shell/view-models/personal-data';
import { RegisterOfficeVM } from 'shell/view-models/register-office-practice-vm';

interface IdentificationProps {
  formContext: FormikProps<RegisterOfficeVM>;
  isOpen: boolean;
  applicantIsAccountholder?: boolean;
  disabled?: boolean;
}

function IdentificationDocumentApplicantComponent({
  formContext,
  isOpen,
  applicantIsAccountholder,
  disabled,
}: IdentificationProps): React.ReactElement {
  const [open, setOpen] = useState<boolean>(isOpen);

  useEffect(() => {
    if (isOpen) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [isOpen]);

  const onChange = useEventCallback(
    (
      key: keyof IdentificationDocument,
      value: IdentificationDocument[keyof IdentificationDocument]
    ) => {
      formContext.setFieldValue('applicantData', {
        ...(formContext.values.applicantData || {}),
        identificationDocument: {
          ...(formContext.values.applicantData?.identificationDocument || {}),
          [key]: value,
        },
      });
    }
  );

  const onFieldsChange = useEventCallback((values: IdentificationDocument) => {
    formContext.setFieldValue('applicantData', {
      ...(formContext.values.applicantData || {}),
      identificationDocument: {
        ...(formContext.values.applicantData?.identificationDocument || {}),
        ...values,
      },
    });
  });

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        if (!applicantIsAccountholder) setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-subject-attributes-content"
        id="panel-person-subject-attributes-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Documento di riconoscimento del richiedente</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <IdentificationDocumentForm
          onChange={onChange}
          onFieldsChange={onFieldsChange}
          values={formContext.values.applicantData?.identificationDocument}
          disabled={disabled}
          errors={
            (formContext.errors.applicantData as FormikErrors<PersonalDataVM>)
              ?.identificationDocument as FormikErrors<IdentificationDocument>
          }
          touched={
            (formContext.touched.applicantData as unknown as FormikTouched<PersonalDataVM>)
              ?.identificationDocument as unknown as FormikTouched<IdentificationDocument>
          }
        />
      </AccordionDetails>
    </Accordion>
  );
}

IdentificationDocumentApplicantComponent.displayName =
  'Applicant Identification Document  component';

const IdentificationDocumentComponent = memo(IdentificationDocumentApplicantComponent);

export default memo(IdentificationDocumentComponent);
